import React from 'react';
import ReactDOM from 'react-dom';
import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';
import {Provider} from '@shopify/app-bridge-react';


// Get shop origin from URL parameters (standard Shopify app pattern)
const urlParams = new URLSearchParams(window.location.search);
const shopOrigin = urlParams.get('shop') || window.location.hostname;
const host = urlParams.get('host');

const config = {
  apiKey: shopOrigin === "bastiano-bonheiden.myshopify.com" ? process.env.REACT_APP_SHOPIFY_API_KEY : process.env.REACT_APP_SHOPIFY_API_KEY_B2B,
  host: host,
  shopOrigin: shopOrigin,
  forceRedirect: true
};

ReactDOM.render(
  <Provider config={config}>
    <App />
  </Provider>,
  document.getElementById('root')
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
